var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-content"},[(_vm.title)?_c('h3',{staticClass:"tab-header"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"tab-description"},[_vm._v("\n        "+_vm._s(_vm.description)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }